module.exports = __webpack_public_path__ + "fonts/Gotham-Bold.635dc9db.eot";